import { useState, useEffect } from 'react';
import axios from 'axios';
import CPFMaskInput from '../masks/CPFMaskInput';
import { API_BASE_URL } from '../../../config/ApiConfig';
import { unformatCPF, formatCPF, isValidCPF } from '../../utils/cpfUtils';
import useDefaultModal from '../hooks/useDefaultModal';
import DefaultModal from '../modals/DefaultModal';

function UsuarioModal({ isOpen, onClose, usuario: usuarioProp, onSave }) {
  const [usuario, setUsuario] = useState({
    cpf: '',
    nome: '',
    login: '',
    senha: '',
    situacao: '',
    role: '',
    cargo: '',
    email: '',
  });
  const [emailError, setEmailError] = useState('');
  const token = localStorage.getItem('token');
  const { setDefaultModal, showDefaultModal } = useDefaultModal();

  useEffect(() => {
    if (usuarioProp) {
      setUsuario(usuarioProp);
    } else {
      setUsuario({
        cpf: '',
        nome: '',
        login: '',
        senha: '',
        situacao: '',
        role: '',
        cargo: '',
        email: '',
      });
    }
  }, [usuarioProp]);

  function handleChange(event) {
    const { name, value } = event.target;
    setUsuario({ ...usuario, [name]: value });

    if (name === 'email') {
      validateEmail(value);
    }
  }

  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      setEmailError('');
    } else if (!re.test(email)) {
      setEmailError('E-mail inválido');
    } else {
      setEmailError('');
    }
  }

  function handleSubmit(event) {
    event.preventDefault();

    if (!isValidCPF(usuario.cpf)) {
      showDefaultModal('error', 'CPF inválido');
      return;
    }

    if (usuario.email && emailError) {
      showDefaultModal('error', 'Por favor, corrija o e-mail antes de salvar');
      return;
    }

    const usuarioParaSalvar = {
      ...usuario,
      cpf: unformatCPF(usuario.cpf),
    };

    axios
      .post(`${API_BASE_URL.USUARIO}/salvar`, usuarioParaSalvar, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        showDefaultModal('success', 'O registro foi salvo com sucesso!', () => {
          onSave && onSave();
          onClose();
        });
      });
  }

  if (!isOpen) return null;

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div
            className="modal-header text-white"
            style={{
              background: 'linear-gradient(45deg, rgb(7, 29, 65) 0%, rgba(29, 100, 216, 1) 100%)',
              padding: '0.5rem 1rem',
              borderTopLeftRadius: '0.5rem',
              borderTopRightRadius: '0.5rem',
              border: 'none',
            }}
          >
            <h6 className="modal-title mb-0">
              <i className="bi bi-person-plus me-2"></i>
              {usuarioProp ? 'Editar Usuário' : 'Novo Usuário'}
            </h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose} title="Fechar"></button>
          </div>
          <div className="modal-body">
            <div className="col-md-12 mx-auto">
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-4 input-group-sm">
                    <label className="form-label">CPF</label>
                    <CPFMaskInput
                      value={formatCPF(usuario.cpf)}
                      onChange={e =>
                        handleChange({
                          target: {
                            name: 'cpf',
                            value: unformatCPF(e.target.value),
                          },
                        })
                      }
                      id="cpf"
                      name="cpf"
                      type="text"
                    />
                  </div>
                  <div className="col-md-8 input-group-sm">
                    <label className="form-label">Nome</label>
                    <input
                      onChange={handleChange}
                      value={usuario.nome}
                      name="nome"
                      type="text"
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-4 input-group-sm">
                    <label className="form-label">Login</label>
                    <input
                      onChange={handleChange}
                      value={usuario.login}
                      name="login"
                      type="text"
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-4 input-group-sm">
                    <label className="form-label">Senha</label>
                    <input
                      onChange={handleChange}
                      value={usuario.senha}
                      name="senha"
                      type="password"
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-4 input-group-sm">
                    <label className="form-label">Situação</label>
                    <select
                      onChange={handleChange}
                      value={usuario.situacao}
                      name="situacao"
                      className="form-select"
                    >
                      <option value=""></option>
                      <option value="ATIVO">ATIVO</option>
                      <option value="INATIVO">INATIVO</option>
                    </select>
                  </div>
                  <div className="col-md-4 input-group-sm">
                    <label className="form-label">Tipo de Usuário</label>
                    <select
                      onChange={handleChange}
                      value={usuario.role}
                      name="role"
                      className="form-select"
                    >
                      <option value=""></option>
                      <option value="ADMIN">ADMINISTRADOR</option>
                      <option value="GEST">GESTOR</option>
                      <option value="USER">USUÁRIO</option>
                    </select>
                  </div>
                  <div className="col-md-8 input-group-sm">
                    <label className="form-label">E-mail</label>
                    <input
                      onChange={handleChange}
                      value={usuario.email}
                      name="email"
                      type="email"
                      className={`form-control ${emailError ? 'is-invalid' : ''}`}
                    />
                    {emailError && (
                      <div className="invalid-feedback">{emailError}</div>
                    )}
                  </div>
                  <div className="col-md-8 input-group-sm">
                    <label className="form-label">Cargo / Função</label>
                    <input
                      onChange={handleChange}
                      value={usuario.cargo}
                      name="cargo"
                      type="text"
                      className="form-control"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>
              <i className="bi bi-x-circle me-1"></i>Cancelar
            </button>
            <button type="button" className="btn btn-success btn-sm" onClick={handleSubmit}>
              <i className="bi bi-check-lg me-1"></i>Salvar
            </button>
          </div>
        </div>
      </div>
      <DefaultModal {...setDefaultModal} />
    </div>
  );
}

export default UsuarioModal;
